export default "__VITE_ASSET__EcmiaYDA__"